var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-mobile-layout',[(_vm.showAppNavigation)?_c('app-navigation',{attrs:{"items":_vm.navigationItems}}):_vm._e(),_c('v-fade-transition',{attrs:{"hide-on-leave":""}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }